/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import moment from 'moment';
import { useEffect, useState } from 'react';

const CountDownTimer = ({ children }: any) => {
  const calculateTimeLeft = () => {
    const eventTime: any = children;
    const currentTime: any = Math.floor(Date.now() / 1000).toString();
    const leftTime = eventTime - currentTime;
    let duration = moment.duration(leftTime, 'seconds');
    const interval = 1000;
    if (duration.asSeconds() <= 0) {
      clearInterval(interval);
      // window.location.reload(true); //#skip the cache and reload the page from the server
    }
    duration = moment.duration(duration.asSeconds() - 1, 'seconds');
    let minutes: any = duration.minutes();
    let seconds: any = duration.seconds();
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    if (seconds > 0 || minutes > 0) {
      return `${minutes}:${seconds}`;
    }
    return '00:00:00';
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  return <span>{timeLeft}</span>;
};
export default CountDownTimer;
